import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute, RouterOutlet } from '@angular/router';
import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';
import { CookieService } from 'ngx-cookie-service';
import { filter, skip } from 'rxjs';
import { take, tap } from 'rxjs/operators';
import { ENVIRONMENT } from '@src/app/providers/providers';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.sass',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterOutlet, HeaderComponent, FooterComponent],
})
export class AppComponent implements OnInit {
  private route = inject(ActivatedRoute);
  private cookieService = inject(CookieService);
  private cookieDomain = inject(ENVIRONMENT).cookieDomain;

  public ngOnInit(): void {
    if (!this.cookieService.get('guid')) {
      this.cookieService.set('guid', this.generateGUID(), 60, '/', this.cookieDomain);
    }
    this.route.queryParams
      .pipe(
        skip(1),
        take(1),
        filter((params) => Object.keys(params).length > 0 && !params['code']),
        tap((params) => {
          let mergedParams = { ...params };
          const landingParams = this.cookieService.get('landing_params');
          if (landingParams) {
            const cookieParams = Object.fromEntries(
              decodeURIComponent(landingParams)
                .split('&')
                .map((pair) => pair.split('=').map(decodeURIComponent))
                .filter(([key]) => key),
            );
            mergedParams = { ...cookieParams, ...mergedParams };
          }
          const encoded = btoa(JSON.stringify(mergedParams));
          this.cookieService.set('url_params', encoded, 30, '/', this.cookieDomain);
        }),
      )
      .subscribe();
  }

  private generateGUID(): string {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
      const r = (Math.random() * 16) | 0;
      const v = c === 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }
}
